import { ScrollView, View } from 'react-native'
import { useRouter } from 'expo-router'
import { useTranslation } from 'react-i18next'
import { SafeAreaView } from 'react-native-safe-area-context'

import { Button } from '@/components/base'
import EnvironmentSwitcher from '@/components/EnvironmentSwitcher'
import BrandLogo from '@/components/BrandLogo'
import LandingCustomerService from '@/components/LandingCustomerService'
import { Stack } from '@/components/layout'

export default function LandingScreen() {
  const router = useRouter()
  const { t } = useTranslation()
  return (
    <>
      <Stack.Screen
        options={{
          headerShown: false
        }}
      />

      <SafeAreaView className={'flex-1 bg-background-primary'}>
        <ScrollView className={'flex-1'} contentContainerStyle={{ flexGrow: 1 }}>
          <View className={'min-h-[220px] grow items-center justify-center py-8'}>
            <EnvironmentSwitcher>
              <BrandLogo variant={'wordmark'} dark />
            </EnvironmentSwitcher>
          </View>
          <View className={'gap-y-3 p-4'}>
            <View className={'mb-6 h-14 items-end'}>
              <LandingCustomerService />
            </View>
            <Button testID={'landing-login'} onPress={() => router.navigate('/login')}>
              {t('auth:login')}
            </Button>
            <Button testID={'landing-register'} variant={'outline'} onPress={() => router.navigate('/register')}>
              {t('auth:register')}
            </Button>
          </View>
        </ScrollView>
      </SafeAreaView>
    </>
  )
}
